import { render, staticRenderFns } from "./SmartTicketPrice.vue?vue&type=template&id=96e42c2c&scoped=true&"
import script from "./SmartTicketPrice.vue?vue&type=script&lang=js&"
export * from "./SmartTicketPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e42c2c",
  null
  
)

export default component.exports